<template>
  <div class="article-list-item" :class="{ disabled: disabled }">
    <div class="info">
      <div class="clearfix">
        <span class="title fl overh" @click="handleTitleClick" v-html="data.title"></span>
        <span
          class="fr"
          v-if="data.implementationStatus"
          :class="data.implementationStatus.indexOf('废止') != -1 ? 'states' : 'state'"
          >{{ data.implementationStatus }}</span
        >
      </div>

      <div class="foot-div">
        <div class="desc">
          <div class="time" v-if="data.releaseTime">
            <img class="timeIcon" src="@/assets/images/pub.png" alt="" />
            发布于:{{ commonTime }}
          </div>
          <div class="time" v-if="data.implementationTime">
            <img class="timeIcon" src="@/assets/images/imple.png" alt="" />
            实施于:{{ commonTimes }}
          </div>
        </div>

        <div class="foot">
          <div class="soure">
            {{ data.releaseDept }}
          </div>
          <div><i class="el-icon-view"></i> {{ data.viewCount }}</div>
          <div @click="handleCollect" class="collectBtn">
            <i :class="data.isCollect ? 'el-icon-star-on' : 'el-icon-star-off'"></i>
            {{ data.isCollect ? "取消收藏" : "收藏" }}
          </div>
        </div>
      </div>
    </div>
    <AdsVue ref="ads" @handleClose="handleTitleClick" />
  </div>
</template>

<script>
import AdsVue from "../../../components/sys/ads";
import { ToText, toTime } from "@/pages/library/assets/js/news.js";

export default {
  components: {
    // itemToolBar,
    AdsVue,
  },
  props: {
    data: {
      type: Object,
      default: () => ({
        id: "",
        title: "",
        coverfileguid: "",
      }),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    layout: {
      type: String,
      default: "views,collect,share,addtime",
    },
    action: {
      type: String,
      default: "",
    },
    collectType: {
      type: String,
      default: "",
    },
    retype: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      coverSrcPath: "",
      loading: null,
    };
  },
  computed: {
    // coverSrc() {
    //     return `${this.$store.state.api.fileUrl}/download/look.do?rowguid=${this.data.coverrowguid}`;
    // },
    desc() {
      var div = document.createElement("div"),
        result = "";

      div.innerHTML = this.data.content.replace("　", "").replace("\\&nbsp;", "");

      if (this.data.coverrowguid) {
        result = div.innerText.slice(0, 78);
      } else {
        result = div.innerText.slice(0, 112);
      }

      div = null;

      return result + "...";
    },

    commonTime() {
      return this.data.releaseTime.indexOf("-") > -1
        ? this.data.releaseTime.split(" ")[0]
        : toTime(this.data.releaseTime, false);
    },
    commonTimes() {
      return this.data.implementationTime.indexOf("-") > -1
        ? this.data.implementationTime.split(" ")[0]
        : toTime(this.data.implementationTime, false);
    },
  },
  methods: {
    // 跳转详情
    handleTitleClick(item) {
      this.$store.dispatch("analysis/updateHits", {
        visitlocation: "标准规范-详情",
      });
      this.loading = this.$loading({
        target: ".loading",
        text: "加载中...",
      });
      this.$ajax({
        type: "get",
        url: this.action,
        data: {
          id: this.data.id,
        },
        callback: (data) => {
          if (data.isView) {
            if (data.httpUrl.indexOf("<a") != -1) {
              let href = data.httpUrl.split('href="')[1].split('">')[0];
              this.judgePath(href);
            } else {
              this.judgePath(data.httpUrl);
            }
          } else {
            if (this.loading) {
              this.loading.close();
            }
            this.$refs.ads.showAdsDialog({
              relationId: item.id ? item.id : this.data.id,
              relationType: this.retype,
            });
          }
        },
        complete: function () {
          if (this.loading) {
            this.loading.close();
          }
        },
      });
    },

    //判断原网站是否可以打开
    judgePath(pathUrl) {
      this.$ajax({
        type: "get",
        url: `${this.$store.state.api.baseWebUrl}/yzkj/information/isViewPlatWeb`,
        data: {
          platWebUrl: pathUrl,
        },
        callback: (data) => {
          this.loading.close();
          if (data.isView) {
            //true代表当前路径可以打开
            window.open(pathUrl);
          } else {
            //路径打不开 需要访问本地页面
            this.$router.push({
              path:
                "/library/documentInfo?articleId=" +
                this.data.id +
                "&source=" +
                "standard",
            });
          }
        },
      });
    },

    // 收藏
    handleCollect() {
      let ajaxType = "";
      let msg = "";
      let data = {};
      if (this.data.isCollect) {
        ajaxType = "put";
        msg = "取消收藏成功";
        data = {
          ids: this.data.id,
        };
      } else {
        ajaxType = "post";
        msg = "收藏成功";
        data = {
          relationId: this.data.id,
          collectType: this.collectType,
        };
      }
      this.$ajax({
        type: ajaxType,
        url: `${this.$store.state.api.baseWebUrl}/yzkj/collect`,
        data,
        callback: (data) => {
          this.data.isCollect = !this.data.isCollect;
          showMsg(msg, "success");
          this.$emit("collect");
        },
      });
    },
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
@import "@css/var.scss";

.article-list-item {
  overflow: hidden;

  &.disabled {
    filter: grayscale(90%);
  }

  .img {
    width: 220px;
    height: 134px;
    float: left;
    background: $primaryColor1;
    margin-right: 15px;
    overflow: hidden;
  }

  .title {
    cursor: pointer;
    display: block;
    font-size: 18px;
    color: #333333;
    line-height: 1em;
    font-weight: bold;
    transition: all 0.3s;
    margin-bottom: 8px;
    max-width: 70%;
    &:hover {
      color: $primaryColor;
    }
    span {
      line-height: 1.5em;
    }
  }

  .foot-div {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
  }
  .desc {
    color: #666;
    font-size: 14px;
    line-height: 24px;
    display: flex;
    justify-content: flex-start;
    margin-top: 10px;
  }

  .overh2 {
    overflow: hidden;
    display: -webkit-box;
    /*将元素设为盒子伸缩模型显示*/
    -webkit-box-orient: vertical;
    /*伸缩方向设为垂直方向*/
    -webkit-line-clamp: 2;
    /*超出2行隐藏，并显示省略号*/
  }

  .foot {
    display: flex;
    justify-content: flex-end;
    align-items: center;

    color: #666;
    font-size: 14px;
    line-height: 24px;
    margin: 7px 0 10px;

    div {
      margin-left: 15px;
    }

    .collectBtn {
      cursor: pointer;
    }
  }
}
.state {
  background-color: #5bc0de;
  padding: 5px 15px;
  color: #fff;
  border-radius: 3px;
  font-size: 12px;
}
.states {
  background-color: #d9001b;
  padding: 5px 15px;
  color: #fff;
  border-radius: 3px;
  font-size: 12px;
}
.time {
  margin-right: 40px;
}
.timeIcon {
  position: relative;
  top: 4px;
  width: 20px;
}
</style>
